/* eslint-disable no-console */
import { put, takeEvery, select } from 'redux-saga/effects';
import { closeModal } from 'actions/modal';
import { getAllJobPosts } from 'api/jobPosts';
import setLoading from 'actions/loading';
import { setAllJobPosts } from 'modules/JobPosts/actions';
import { startSearchByLocationSubmit, resolveSearchByLocationSubmit } from './actions';

export function* searchByLocationSaga(action: any) {
  const { token } = yield select(state => state.user);

  const locationFilter = { where: action.payload };
  try {
    yield put(setLoading(true));
    const jobPostsByLocation = yield getAllJobPosts(token, JSON.stringify(locationFilter));
    yield put(setLoading(false));

    yield put(setAllJobPosts(jobPostsByLocation.data.jobs));
    yield put(resolveSearchByLocationSubmit());

    yield put(closeModal());
  } catch (error) {
    yield put(setLoading(false));
    yield put(resolveSearchByLocationSubmit(error.response));
  }
}

export default function* searchByLocationSagas() {
  yield takeEvery(startSearchByLocationSubmit, searchByLocationSaga);
}
